import ui from "./ui.js";
import materials from "./materials.js";
import * as THREE from "three";



export default function options(model, originalMaterial, scene, camera){
    const {mainRadios, equipmentCheckbox, materialRadios, islandRadios} = ui()
    let firstLoadForMain = true
    let firstLoadForMaterial = true
    const priceValue = document.querySelector('.price-value')

    const defaultPrice = 6000

    const { materialWoodLight, materialWoodMedium} = materials(scene)
    const urlParams = new URLSearchParams(window.location.search);

    const mainParam = urlParams.get('main');
    const materialsParam = urlParams.get('materials');

    const colorSettings = {
        duration: 600,
        color: '#ffffff'
    };

    // gui.add(colorSettings, 'duration', 100, 2000, 50).name('Время смены (мс)');
    // gui.addColor(colorSettings, 'color').name('Цвет').onChange((hex) => {
    //     changeColor(hex);
    // });



    mainRadios.forEach((item)=>{
        if (mainParam === item.value && firstLoadForMain) {
            item.checked = true
            changeColor(mainParam)
            firstLoadForMain = false
        }

        item.addEventListener('change', event => {
            changeColor(event.target.value)
        });


    })

    function changeColor(hex) {
        const targetColor = new THREE.Color(hex);
        const duration = colorSettings.duration; // берём из GUI
        const startTime = performance.now();

        const materials = [];
        scene.traverse((child) => {
            if (!child.isMesh || !child.material) return;
            const mats = Array.isArray(child.material) ? child.material : [child.material];
            mats.forEach(mat => {
                if (!mat.name) return;
                const name = mat.name.toLowerCase();
                if (name.includes('roof') || name.includes('metal_tubes') || name.includes('plastic_black')) {
                    materials.push({
                        mat,
                        startColor: mat.color.clone()
                    });
                }
            });
        });

        function animate() {
            const elapsed = performance.now() - startTime;
            const t = Math.min(elapsed / duration, 1);
            const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

            materials.forEach(({ mat, startColor }) => {
                mat.color.copy(startColor).lerp(targetColor, eased);
                mat.needsUpdate = true;
            });

            if (t < 1) requestAnimationFrame(animate);
        }

        animate();
    }


    equipmentCheckbox.forEach((item)=>{
        item.addEventListener('change', event => {
            changeEquipment(event.target.dataset.text, event.target.checked)
        });

        function changeEquipment(data, value){
            calculatePrice()

            model.traverse( (child) => {

                switch (data) {
                    case 'Lattice nook':
                        if (child.name.toLowerCase().includes('lattice_nook')) {
                            child.visible = true
                        }

                        if (child.name.toLowerCase().includes('shade_deck')) {
                            child.visible = false
                        }

                        if (child.name.toLowerCase().includes('split_cover')) {
                            child.visible = false
                        }
                        break;

                    case 'Shade deck':
                        if (child.name.toLowerCase().includes('lattice_nook')) {
                            child.visible = false
                        }

                        if (child.name.toLowerCase().includes('shade_deck')) {
                            child.visible = true
                        }

                        if (child.name.toLowerCase().includes('split_cover')) {
                            child.visible = false
                        }
                        break;

                    case 'Split cover':
                        if (child.name.toLowerCase().includes('lattice_nook')) {
                            child.visible = false
                        }

                        if (child.name.toLowerCase().includes('shade_deck')) {
                            child.visible = false
                        }

                        if (child.name.toLowerCase().includes('split_cover')) {
                            child.visible = true
                        }
                        break;
                }
            });
        }
    })
    //
    islandRadios.forEach((item)=>{
        item.addEventListener('change', event => {
            changeEquipment(event.target.dataset.text, event.target.checked)
        });

        function changeEquipment(data, value){
            calculatePrice()

            model.traverse( (child) => {

                if (child.name === 'furniture') {
                    child.visible = value
                }

            });
        }
    })
    //
    materialRadios.forEach((item)=>{
        if (materialsParam === item.value && firstLoadForMaterial) {
            item.checked = true
            changeMaterial(materialsParam)
            firstLoadForMaterial = false
        }

        item.addEventListener('change', event => {
            changeMaterial(event.target.value)
        })

        function changeMaterial(data){
            calculatePrice()


            model.traverse( (child) => {
                if (child.isMesh) {

                    if (child.material.name === 'Wood_outside') {
                        if (data === 'default'){
                            child.material = originalMaterial
                            child.material.name = 'Wood_outside'
                        }

                        if (data === 'light'){
                            child.material = materialWoodLight
                            child.material.name = 'Wood_outside'
                        }

                        if (data === 'medium'){
                            child.material = materialWoodMedium
                            child.material.name = 'Wood_outside'
                        }
                    }
                }
            })
        }

    })

    function calculatePrice(){
        let price = defaultPrice

        mainRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        islandRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })


        equipmentCheckbox.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        priceValue.textContent = price

    }
}